module.exports = __webpack_public_path__ + "static/media/cornerKo.639ace4e.svg";